import React, { useEffect, useState } from "react";
import { Menu, X, Cpu, Phone } from "lucide-react";
import { businessInfo } from "../mock";

const links = [
  { href: "/#services", label: "Υπηρεσίες" },
  { href: "/#areas", label: "Περιοχές" },
  { href: "/#gallery", label: "Εργασίες" },
  { href: "/#reviews", label: "Κριτικές" },
  { href: "/blog", label: "Blog" },
  { href: "/#faq", label: "FAQ" },
  { href: "/#contact", label: "Επικοινωνία" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#050b16cc] backdrop-blur-md border-b border-emerald-900/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2 group">
          <div className="relative">
            <div className="w-9 h-9 rounded-md bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center glow-green">
              <Cpu className="w-5 h-5 text-emerald-400" />
            </div>
          </div>
          <div className="leading-tight">
            <div className="text-white font-bold tracking-tight">
              {businessInfo.name}
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-emerald-400/80">
              Repair Lab
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-6 mx-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-emerald-50/80 hover:text-emerald-300 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${businessInfo.mobile}`}
            className="btn-outline rounded-md px-3 py-2 text-sm inline-flex items-center gap-2"
          >
            <Phone className="w-4 h-4" /> {businessInfo.mobile}
          </a>
          <a
            href={`tel:${businessInfo.mobile2}`}
            className="btn-outline rounded-md px-3 py-2 text-sm inline-flex items-center gap-2"
          >
            <Phone className="w-4 h-4" /> {businessInfo.mobile2}
          </a>
          <a
            href="/#contact"
            data-cta="book_appointment"
            className="btn-primary rounded-md px-4 py-2 text-sm"
          >
            Κλείστε ραντεβού
          </a>
        </div>

        <button
          aria-label="menu"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden w-10 h-10 inline-flex items-center justify-center rounded-md border border-emerald-700/40 text-emerald-200"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-emerald-900/50 bg-[#050b16ee] backdrop-blur-md">
          <div className="px-5 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-emerald-100/90"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${businessInfo.mobile}`}
              className="btn-outline rounded-md px-4 py-2 text-sm inline-flex items-center gap-2 justify-center"
            >
              <Phone className="w-4 h-4" /> {businessInfo.mobile}
            </a>
            <a
              href={`tel:${businessInfo.mobile2}`}
              className="btn-outline rounded-md px-4 py-2 text-sm inline-flex items-center gap-2 justify-center"
            >
              <Phone className="w-4 h-4" /> {businessInfo.mobile2}
            </a>
            <a
              href="/#contact"
              data-cta="book_appointment_mobile"
              onClick={() => setOpen(false)}
              className="btn-primary rounded-md px-4 py-2 text-sm text-center"
            >
              Κλείστε ραντεβού
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
